import { render } from "./AVDA.vue?vue&type=template&id=26858442&scoped=true"
import script from "./AVDA.vue?vue&type=script&lang=js"
export * from "./AVDA.vue?vue&type=script&lang=js"

import "./AVDA.vue?vue&type=style&index=0&id=26858442&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26858442"]])

export default __exports__